const apiPrefixUrl = 'https://www.kfsyscc.org/normal_api/service'

export {
    apiPrefixUrl
}